import * as React from "react";
import { Link, NavLink, Route, Routes } from "react-router-dom";
import { Spinner } from "utils";

const Index = React.lazy(() => import("./routes/index"));
const Dashboard = React.lazy(() => import("./routes/dashboard"));
const Nfts = React.lazy(() => import("./routes/nfts"));
const SalesIndex = React.lazy(() => import("./routes/sales/index"));
const Subscriptions = React.lazy(() => import("./routes/sales/subscriptions"));
const Customers = React.lazy(() => import("./routes/sales/customers"));
const Deposits = React.lazy(() => import("./routes/sales/deposits"));
const Invoices = React.lazy(() => import("./routes/sales/invoices"));
const InvoicesIndex = React.lazy(() => import("./routes/sales/invoices/index"));
const Invoice = React.lazy(() => import("./routes/sales/invoices/$invoiceId"));

const Spinnit = ({ children }: { children: React.ReactNode }) => (
  <React.Suspense fallback={<Spinner className="p-32" />}>
    {children}
  </React.Suspense>
);

const SmallSpinnit = ({ children }: { children: React.ReactNode }) => (
  <React.Suspense fallback={<Spinner className="p-8 h-[6rem]" />}>
    {children}
  </React.Suspense>
);

export default function App() {
  return (
    <Fakebooks>
      <Spinnit>
        <Routes>
          <Route>
            <Route
              path="dashboard"
              element={
                <Spinnit>
                  <Dashboard />
                </Spinnit>
              }
            />
            <Route
              index
              element={
                <Spinnit>
                  <Index />
                </Spinnit>
              }
            />
            <Route
              path="nfts"
              element={
                <Spinnit>
                  <Nfts />
                </Spinnit>
              }
            >
              <Route
                path="subscriptions"
                element={
                  <Spinnit>
                    <Subscriptions />
                  </Spinnit>
                }
              />
              <Route
                path="customers"
                element={
                  <Spinnit>
                    <Customers />
                  </Spinnit>
                }
              />
              <Route
                path="deposits"
                element={
                  <Spinnit>
                    <Deposits />
                  </Spinnit>
                }
              />
              <Route
                path="invoices"
                element={
                  <SmallSpinnit>
                    <Invoices />
                  </SmallSpinnit>
                }
              >
                <Route
                  path=":invoiceId"
                  element={
                    <SmallSpinnit>
                      <Invoice />
                    </SmallSpinnit>
                  }
                />
                <Route
                  index
                  element={
                    <SmallSpinnit>
                      <InvoicesIndex />
                    </SmallSpinnit>
                  }
                />
              </Route>
              <Route
                index
                element={
                  <Spinnit>
                    <SalesIndex />
                  </Spinnit>
                }
              />
            </Route>
          </Route>
        </Routes>
      </Spinnit>
    </Fakebooks>
  );
}

function Fakebooks({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative flex h-full rounded-lg bg-white text-gray-600">
      <div className="border-r border-gray-100 bg-gray-50">
        <div className="p-4">
          <Link to="." className="flex items-center text-[color:#23BF1F]">
            <div className="w-1" />
            <div className="font-display text-d-p-sm">CovFolio</div>
          </Link>
          <div className="h-7" />
          <div className="flex flex-col font-bold text-gray-800">
            <NavItem to="">Dashboard</NavItem>
            <NavItem to="nfts">
              <del>NFTs</del>
            </NavItem>
            <a
              href="https://github.com/nlnw/ethnewyork-covfolio"
              className="my-1 py-1 px-2 pr-16 text-[length:14px]"
            >
              GitHub ↗️
            </a>
          </div>
        </div>
      </div>
      <div className="flex-1">{children}</div>
    </div>
  );
}

function NavItem({
  to,
  children,
}: {
  to: string;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `my-1 py-1 px-2 pr-16 text-[length:14px] ${
          isActive ? "rounded-md bg-gray-100" : ""
        }`
      }
    >
      {children}
    </NavLink>
  );
}
